import { State } from '../../store';

import { TrackingInfo } from '../../client/services/types';

export const getBarCode = ({ tracking }: State): string => tracking.barcode;
export const getTrackingList = ({ tracking }: State): TrackingInfo[] => tracking.trackingList;
